'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.sendCode = sendCode;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SEND = 'redux-frontend/affiliate/SEND';
var SEND_SUCCESS = 'redux-frontend/affiliate/SEND_SUCCESS';
var SEND_FAIL = 'redux-frontend/affiliate/SEND_FAIL';

var initialState = {
  sending: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SEND:
      return (0, _extends3.default)({}, state, {
        sending: true
      });
    case SEND_SUCCESS:
      return (0, _extends3.default)({}, state, {
        sending: false
      });
    case SEND_FAIL:
      return (0, _extends3.default)({}, state, {
        sending: false
      });
    default:
      return state;
  }
}

function sendCode(code, email) {
  return {
    types: [SEND, SEND_SUCCESS, SEND_FAIL],
    promise: function promise(client) {
      return client.post('/affiliate/send', { data: { code: code, email: email } });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/affiliate.js
// module id = 679
// module chunks = 47